<template>
  <div>
    <v-app-bar fixed color="primary" dark app>
      <v-btn class="mr-2 hidden-sm-and-down" text @click="goHome">
        <v-icon left>mdi-home</v-icon> {{ locale[local].screen.toolbar.start }}
      </v-btn>

      <v-img
        height="38"
        width="56"
        style="max-width: 56px"
        class="mr-4"
        :src="`logo-pequeno.png`"
        :lazy-src="`logo-pequeno.png`"
        contain
        @click="goHome"
      >
      </v-img>

      <!--       <v-toolbar-title>{{ this.$clienteNome }}
      </v-toolbar-title> -->
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-avatar size="36" class="mt-4">
          <img
            :src="urlImagem ? urlImagem : `profile.png`"
            @error="imageLoadError"
            :alt="locale[local].screen.toolbar.imageAlt"
          />
        </v-avatar>

        <v-btn text @click="goDadosCadastrais">
          <!-- <v-icon left>mdi-account</v-icon>  -->
          {{ nomeUsuarioLogado }}
        </v-btn>
        <v-btn text @click="dialog = true">
          <v-icon left>mdi-lock-question</v-icon
          >{{ locale[local].screen.toolbar.btnChangePass }}
        </v-btn>
        <v-menu>
          <template v-slot:activator="{ on: menu }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on: tooltip }">
                <v-btn color="primary" dark v-on="{ ...tooltip, ...menu }">
                  <v-badge
                    color=" red"
                    :content="avisosNaoLido"
                    :value="avisosNaoLido > 0"
                  >
                    <v-icon left>mdi-bell </v-icon
                    >{{ locale[local].screen.toolbar.btnWarnings }}
                  </v-badge>
                </v-btn>
              </template>
              <span>{{ locale[local].screen.toolbar.btnWarnings }}</span>
            </v-tooltip>
          </template>
          <v-list>
            <v-list-item
              v-for="(aviso, index) in avisos"
              :key="index"
              two-line
              @click="goAvisos"
              :class="{ unread: aviso.situacao == 'N' }"
            >
              <v-list-item-content>
                <v-list-item-title
                  :class="{ unread_text: aviso.situacao == 'N' }"
                >
                  <div v-if="aviso.mensagem.length < 25">
                    {{ aviso.mensagem }}
                  </div>
                  <div v-else>
                    {{ aviso.mensagem.substring(0, 25) + "..." }}
                  </div>
                </v-list-item-title>

                <v-list-item-subtitle
                  :class="{ unread_text: aviso.situacao == 'N' }"
                >
                  {{
                    aviso.dtAviso.substring(8) +
                    "/" +
                    aviso.dtAviso.substring(5, 7) +
                    "/" +
                    aviso.dtAviso.substring(0, 4)
                  }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item dense link @click="goAvisos">
              <v-list-item-title class="caption blue--text">
                {{ locale[local].screen.toolbar.showAllWarnings }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-select
          :items="locales"
          item-text="name"
          item-value="key"
          v-model="localeSelected"
          hide-details
          single-line
          style="max-width: 250px"
          @change="changeLocale"
          return-object
          no-data
          class="mt-2"
        >
          <template v-slot:item="{ item }">
            <country-flag :country="item.flag" size="normal" />
            <span>{{ item.name }}</span>
          </template>

          <template v-slot:prepend-inner>
            <country-flag :country="localeSelected.flag" size="normal" />
          </template>
        </v-select>

        <v-btn text @click="logout">
          <v-icon left>mdi-exit-to-app</v-icon
          >{{ locale[local].screen.toolbar.btnLogout }}
        </v-btn>
      </v-toolbar-items>

      <v-app-bar-nav-icon class="hidden-md-and-up" @click="drawer = !drawer">
      </v-app-bar-nav-icon>
    </v-app-bar>

    <div @mouseleave="drawer = false" class="hidden-md-and-up">
      <v-navigation-drawer
        v-model="drawer"
        app
        hide-overlay
        fixed
        clipped
        color="nav"
        id="keep"
        right
      >
        <v-list dense nav class="py-0">
          <v-list-item two-line class="px-0">
            <v-list-item-avatar>
              <img :src="urlImagem" />
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title
                >{{ locale[local].screen.toolbar.wellcome }},</v-list-item-title
              >
              <v-list-item-subtitle
                ><strong>{{ nomeUsuarioLogado }}</strong></v-list-item-subtitle
              >
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-list class="text-left" nav dense mandatory>
          <v-list-item
            v-for="(item, i) in itemsMenu"
            :key="i"
            @click="item.funcao"
          >
            <v-list-item-icon style="width: 24px">
              <v-icon v-if="item.badge == null">{{ item.icone }}</v-icon>
              <template v-else>
                <v-badge
                  color=" red"
                  :content="avisosNaoLido"
                  :value="avisosNaoLido > 0"
                  overlap
                >
                  <v-icon left>mdi-bell</v-icon>
                </v-badge>
              </template>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.texto }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
    </div>

    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title
          class="headline primary"
          style="color: white"
          primary-title
          >{{ locale[local].screen.toolbar.btnChangePass }} !</v-card-title
        >
        <v-card-text class="pb-0">
          <v-form ref="formSenha">
            <v-layout row wrap>
              <v-flex xs12 class="pt-4">
                <v-text-field
                  v-model="novaSenha"
                  :label="locale[local].screen.toolbar.labelChangePass"
                  filled=""
                  :rules="
                    this.$senhaApenasNumerica ? senhaNumericaRules : senhaRules
                  "
                  counter="6"
                  required
                  :append-icon="senhaVisivel ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="() => (senhaVisivel = !senhaVisivel)"
                  :type="senhaVisivel ? 'password' : 'text'"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="primary" text @click="dialog = false">{{
            locale[local].screen.login.dialog2.btnCancelLabel
          }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="alteraSenha">{{
            locale[local].screen.login.dialog2.btnUpdateLabel
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <cgi-alerta ref="alerta" />

    <v-dialog v-model="msg" width="570">
      <v-card>
        <v-card-title
          class="headline primary"
          style="color: white"
          primary-title
        >
          <v-card-text
            class="text-h5 font-weight-bold"
            style="word-break: break-word"
          >
            {{ titulo }}
          </v-card-text>

          <!-- <v-spacer></v-spacer>
          <v-spacer></v-spacer> -->
        </v-card-title>
        <v-card-text class="py-10" style="font-size: 18px">
          {{ mensagem }}
        </v-card-text>

        <div class="d-inline-block text-left">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" @click="downloadItem(avisosDialog[0])">
                Clique Aqui para ver o anexo
                <v-icon
                  v-show="temAnexo != ''"
                  color="primary"
                  @click="downloadItem(avisosDialog[0])"
                  >mdi-paperclip</v-icon
                >
              </v-btn>
            </template>
            <span>{{ locale[local].screen.avisos.possuiAnexosLavel }}</span>
          </v-tooltip>
        </div>

        <v-card-actions>
          <v-btn
            @click="atualizaSituacao(avisosDialog[0])"
            color="primary"
            block
            >Marcar como lido</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import LoginVue from "@/views/Login";
import Service from "@/components/api/Service";
import { locale } from "../../locale/locale";
import moment from "moment";
import { alert } from "cids-cgi/lib/util";
import axios from "axios";

export default {
  data: (vm) => ({
    localeSelected: {
      flag: "br",
    },
    locales: [
      {
        name: "Português - Brasil",
        key: "pt-BR",
        flag: "br",
      },
      {
        name: "Inglês",
        key: "en-US",
        flag: "us",
      },
      {
        name: "Espanhol",
        key: "es",
        flag: "es",
      },
    ],
    // Functions
    service: new Service(),

    nomeUsuarioLogado: null,
    drawer: null,
    dialog: false,
    msg: false,
    senhaVisivel: true,
    novaSenha: null,
    urlImagem: null,
    avisos: [],
    titulo: "",
    mensagem: "",
    temAnexo: "",
    avisosNaoLido: 0,
    avisosDialog: [],
    avisosDialogAssinatura: [],
    itemsMenu: [
      { icone: "mdi-home", texto: "Inicio", funcao: vm.goHome },
      {
        badge: "mdi-bell",
        texto: "Avisos",
        funcao: vm.goAvisos,
      },
      {
        icone: "mdi-account",
        texto: "Dados Cadastrais",
        funcao: vm.goDadosCadastrais,
      },
      {
        icone: "mdi-lock-question",
        texto: "Alterar Senha",
        funcao: vm.abreDialogAlterarSenha,
      },
      { icone: "mdi-exit-to-app", texto: "Sair", funcao: vm.logout },
    ],
    senhaRules: [(v) => !!v || locale[window.local].rules.passwordLabel],
    senhaNumericaRules: [
      (v) => !!v || locale[window.local].rules.passwordLabel,
      (v) => {
        if (!v.trim()) return true;
        if (!isNaN(parseFloat(v)) && v >= 0) return true;
        return locale[window.local].rules.passwordLabelJustNumbers;
      },
      (v) =>
        vm.validaNumerosIguaisSeguidos(v) ||
        locale[window.local].rules.passwordLabel2EqualNumbers,
      (v) =>
        vm.validaNumerosSequencias(v) ||
        locale[window.local].rules.passwordLabel3EqualNumbers,
      ,
      (v) =>
        (v && v.length == 6) ||
        locale[window.local].rules.passwordMin6Characteres,
    ],
  }),
  created() {
    this.drawer = false;
    this.nomeUsuarioLogado = localStorage.getItem("nomePessoa");
    this.urlImagem = this.service.buscaImagemPerfil();
    this.atualizarQuantidadeAvisosNaoLidos();
  },
  mounted() {
    this.localeSelected = this.locales.filter(
      (locale) => locale.key == window.local
    )[0];
    this.$root.$on("atualizarUrlImagem", () => {
      this.urlImagem = this.service.buscaImagemPerfil();
    });

    this.$root.$on("atualizarNomeUsuarioLogado", () => {
      this.nomeUsuarioLogado = localStorage.getItem("nomePessoa");
    });

    this.$root.$on("atualizarQuantidadeAvisos", () => {
      this.atualizarQuantidadeAvisosNaoLidos();
    });
  },
  methods: {
    changeLocale(local) {
      localStorage.setItem("local", local.key);
      window.location.reload();
    },
    goHome() {
      // eslint-disable-next-line no-unused-vars
      this.$router.push("/").catch((err) => {
        window.location.reload();
      });
    },
    goDadosCadastrais() {
      this.$router.push("dadoscadastrais");
    },
    goAvisos() {
      this.$router.push("avisos");
    },
    logout() {
      localStorage.removeItem("codPessoa");
      sessionStorage.removeItem("logado");
      localStorage.removeItem("nomePessoa");
      localStorage.removeItem("hash");
      this.$emit("home", LoginVue);
      this.goHome();
      this.$emit("login", LoginVue);
    },
    abreDialogAlterarSenha() {
      this.dialog = true;
    },
    async alteraSenha() {
      if (!this.$refs.formSenha.validate()) return;
      let codPessoa = parseInt(localStorage.getItem("codPessoa"));
      var response = await this.service.alterarSenha(this.novaSenha, codPessoa);
      if (response.data.retorno[0].estatus === "Sucesso") {
        this.dialog = false;
        localStorage.setItem("hash", btoa(this.novaSenha));
        this.novaSenha = null;
        this.$refs.alerta.mostrarMensagem(
          response.data.retorno[0].msgErro,
          "green",
          true
        );
      } else {
        this.$refs.alerta.mostrarMensagem(
          "Erro ao trocar a senha",
          "red",
          true
        );
      }
    },
    imageLoadError() {
      event.target.src = "profile.png";
    },
    async atualizarQuantidadeAvisosNaoLidos() {
      try {
        var resposta = await this.service.buscarAvisos({
          codPessoa: parseInt(localStorage.getItem("codPessoa")),
          todos: false,
        });

        if (resposta.status === 200) {
          if (resposta.data.retorno) {
            if (resposta.data.retorno[0].estatus === "Erro") {
              throw new Error(resposta.data.retorno[0].msgErro);
            }
          }

          this.avisosNaoLido = resposta.data.Avisos.filter(
            (x) => x.situacao == "N"
          ).length;

          this.avisos = resposta.data.Avisos;
          this.avisos.reverse();
          this.avisos = this.avisos.slice(0, 3);

          if (this.avisosNaoLido > 0) {
            this.avisosDialog = resposta.data.Avisos.filter(
              (x) =>
                x.mostraMensagem == true &&
                x.observacao != "Você tem documento pendente de Assinatura!!!"
            );

            if (this.avisosDialog.length > 0) {
              this.titulo = this.avisosDialog[0].observacao;
              this.mensagem = this.avisosDialog[0].justificativa;
              this.temAnexo = this.avisosDialog[0].sequenciaAnexo;
              this.msg = true;
            } else {
              this.avisosDialogAssinatura = resposta.data.Avisos.filter(
                (x) =>
                  x.mostraMensagem == true &&
                  x.observacao ===
                    "Você tem documento pendente de Assinatura!!!"
              );

              if (this.avisosDialogAssinatura.length > 0) {
                let confirm;
                confirm = await alert.confirm({
                  message:
                    this.avisosDialogAssinatura[0].observacao +
                    ` Deseja assinar ?`,
                  color: "warning",
                });

                if (confirm) {
                  this.atualizaSituacao(this.avisosDialogAssinatura[0]);
                  this.$router.push("documentos");
                } else {
                  this.atualizaSituacao(this.avisosDialogAssinatura[0]);
                  //this.$root.$emit("atualizarQuantidadeAvisos");
                }
              }
            }
          }
        } else {
          throw new Error();
        }
      } catch (e) {
        this.loading = false;
      }
    },
    async atualizaSituacao(item) {
      let dataAviso = moment(item.dtAviso);
      var resposta = await this.service.alteraSituacaoAviso({
        codPessoa: parseInt(localStorage.getItem("codPessoa")),
        codEmp: parseInt(item.codEmp),
        codEmpregado: parseInt(item.codEmpregado),
        dtAviso:
          dataAviso.format("DD") +
          "-" +
          dataAviso.format("MM") +
          "-" +
          dataAviso.format("YYYY"),
        sequencia: parseInt(item.sequencia),
      });

      this.msg = false;
      this.$root.$emit("atualizarQuantidadeAvisos");

      if (resposta.status != 200) {
        throw new Error();
      }
    },
    validaNumerosIguaisSeguidos(novaSenha) {
      for (let i = 0; i < novaSenha.length - 1; i++) {
        if (novaSenha[i] === novaSenha[i + 1]) {
          return false;
        }
      }
      return true;
    },
    validaNumerosSequencias(novaSenha) {
      for (let i = 0; i < novaSenha.length - 2; i++) {
        if (
          parseInt(novaSenha[i]) + 1 === parseInt(novaSenha[i + 1]) &&
          parseInt(novaSenha[i]) + 2 === parseInt(novaSenha[i + 2])
        ) {
          return false;
        }
      }
      return true;
    },
    downloadItem(aviso) {
      let dataAviso = moment(aviso.dtAviso);
      let dataAvisoFormatado = dataAviso.format("YYYYMMDD");

      var url = this.service.buscaAnexo(
        aviso.codEmp,
        aviso.codEmpregado,
        aviso.codMensagem,
        aviso.sequencia,
        dataAvisoFormatado,
        aviso.sequenciaAnexo
      );

      axios
        .get(url, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          const blob = new Blob([response.data], {
            type: this.detectMimeType(aviso.extensaoAnexo),
          });
          const blobUrl = window.URL.createObjectURL(blob);

          window.open(blobUrl, "_blank");
        });
    },
    detectMimeType(ext) {
      switch (ext.toLowerCase()) {
        case "pdf": return "application/pdf";
        case "jpg":
        case "jpeg": return "image/jpeg";
        case "png": return "image/png";
        case "txt": return "text/plain";
        case "html": return "text/html";
        default: return "application/octet-stream"; // tipo genérico
      }
    },    
  },
};
</script>

<style scoped>
.unread {
  background-color: lightgrey;
}

.unread_text {
  font-weight: bold;
}
</style>
